/* eslint prefer-template:0 */

import joinURL from '../common/joinURL.js'

export default function miniPackages(window, requirejs) {
  // Prefetch font CSS files
  // By marking them as media="none" their download is made non-blocking
  // (At least for WebKit / Blink browsers)
  // (WixThemeReact may remove this attribute)
  requirejs(['lodash', 'fonts'], (_, fonts) => {
    const { document, location = {} } = window

    function enableLink() {
      this.removeAttribute('media')
    }

    const cssUrls = {}
    if (!document.querySelector('link[href$="viewer.css"]')) {
      cssUrls.viewer = joinURL(window.santaBase, 'static/css/viewer.css')
    }

    if (location.hostname !== 'localhost') {
      _.assign(cssUrls, fonts.fontUtils.getCssUrls(window.rendererModel.siteInfo.documentType, window.serviceTopology))
    }

    _.forEach(cssUrls, (url, id) => {
      const link = document.createElement('link')
      link.setAttribute('rel', 'stylesheet')
      link.setAttribute('href', url)
      link.setAttribute('media', 'none')
      link.setAttribute('id', 'font_' + id)
      link.addEventListener('load', enableLink, false)
      document.head.appendChild(link)
    })
  })
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/miniPackages.js